import React from "react";
import "./Footer.css";
import { FaWhatsapp, FaFacebookF, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* About */}
        <div className="footer-col">
          <h3>About Uzhavan Taxi</h3>
          <p>
            We provide 24/7 safe and comfortable taxi services in and around
            Thanjavur. Whether it’s a city ride, airport drop, or long trip, our
            professional drivers ensure a smooth journey.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#tariff">Tariff</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-col">
          <h3>Contact Us</h3>
          <p>📍 1st Floor, Cavery illam, 105, Thennamara Salai, opp. CallTax Road, Mayiladuthurai</p>
          <p>📞 +91 9585306000</p>
          <p>✉️ info@uzhavantaxi.com</p>
        </div>

        {/* Follow Us */}
        <div className="footer-col">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a
              href="https://wa.me/919585306000"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.facebook.com/uzhavan.taxi/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/uzhavantaxi/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2025 Uzhavan Taxi. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;

